import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./APISection.css";

export default function APISection() {
  const apis = [
    {
      title: "Diamond Exchange Sports API",
      desc: "360 Gaming Labs - #1 Diamond Exchange Sports API provider with real-time odds, market depth, and seamless trading for Diamond Exchange-style sports platforms. Built for speed, accuracy, security, stability and large-scale sports exchange operations."
    },
    {
      title: "Diamond Exchange Casino API",
      desc: "360 Gaming Labs - #1 Diamond Exchange Casino API provider with 68+ diamond casino tables with fast, secure, and scalable connectivity tailored for Diamond Exchange systems. Enjoy smooth gameplay, instant results, and stable performance across all devices."
    },
    {
      title: "International Live Casino API",
      desc: "360 Gaming Labs provides Access to the world-class live 10,000 Crash, Live Dealers, Slots & International casino games from global providers with HD streaming and flawless integration. Deliver immersive experiences with real-time interactions & secure gameplay."
    },
    {
      title: "Betfair Sportsbook Iframe API",
      desc: "360 Gaming Labs offers Embed Betfair-style sportsbook interfaces instantly with an optimized iframe setup. Get dynamic odds, live betting markets, smooth user interactions without heavy development and can go live instantly with our Iframe Solutions."
    },
    {
      title: "Sports Exchange Iframe API",
      desc: "Launch a full sports exchange UI instantly using our fast, customizable iframe integration. Offers real-time odds, instant bet placement, and smooth market updates with zero latency. 360 Gaming Labs is the best Sports Exchange Iframe providers across the Globe."
    },
    {
      title: "Live Streaming and Results API",
      desc: "Stream live matches and fetch accurate results in real time through our advanced API engine. Ideal for sportsbooks, exchanges, and casino platforms needing instant updates and seamless engagement. 360 Gaming Labs is the best Diamond Exchange API providers across the Globe."
    }
  ];

  return (
    <section id="api" className="api-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">API Solutions</div>
          <h2 className="section-title">
            Build & Scale with Our<br />
            <span className="gradient-text">Sports and International Casino API Solutions</span>
          </h2>
          <p className="section-subtitle">
            by 360 Gaming Labs
          </p>
        </div>

        <div className="api-grid">
          {apis.map((api, i) => (
            <div key={i} className="api-card" data-index={i}>
              <h3 className="api-title">{api.title}</h3>
              <p className="api-description">{api.desc}</p>

              <div className="api-actions">
                <button className="api-btn-explore">
                  <span>Explore API</span>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M3 8h10m0 0l-3-3m3 3l-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                </button>
                <button className="api-btn-demo">Demo</button>
              </div>

              <div className="card-glow"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
